import { render } from "./Servicios.vue?vue&type=template&id=3bfbc3cc"
const script = {}
script.render = render

export default script